<template>
    <div v-if="tools.length <= collapseThreshold">
        <AiChatMessageBubble
            v-for="tool in tools"
            :key="tool.id"
            :message="tool"
        />
    </div>
    <div v-else class="my-1 text-left text-xs text-gray-400">
        <button
            type="button"
            class="inline-flex cursor-pointer items-center gap-1 rounded transition hover:text-gray-600"
            :aria-expanded="expanded"
            @click="expanded = !expanded"
        >
            <ChevronRightIcon
                class="h-3 w-3 shrink-0 transition-transform"
                :class="expanded ? 'rotate-90' : ''"
            />
            {{ t("vue.ai_chat_tools_loaded_group", { count: tools.length }) }}
        </button>
        <div v-if="expanded" class="mt-1 border-l border-gray-200 pl-3">
            <AiChatMessageBubble
                v-for="tool in tools"
                :key="tool.id"
                :message="tool"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { ChevronRightIcon } from "@heroicons/vue/24/outline";
import type { IAiChatMessage } from "@/types/AiChat/IAiChat";
import { useTranslations } from "@/composables/useTranslations";

defineProps<{
    tools: IAiChatMessage[];
}>();

const { t } = useTranslations();

const collapseThreshold = 3;
const expanded = ref(false);
</script>
